import api from '@/sui/api/password'
import password from '@/sui/tools/password'

const state = {
  status: ''
}

const getters = {
  isReset: state => {
    return state.status === 'reset'
  }
}

const actions = {
  reset ({ commit }, request) {
    const pwd = password(request.email, request.password)
    const prefix = request.prefix != null ? request.prefix : ''
    return api.resetPassword(prefix, request.id, request.email, pwd).then(
      (response) => {
        if (response.data.err == null) {
          commit('setStatus', 'reset')
        }
        return response
      }
    )
  },

  init (_, request) {
    const prefix = request.prefix != null ? request.prefix : ''
    return api.initPassword(
      prefix,
      request.name,
      request.firstName,
      request.email,
      request.source
    ).then((response) => {
      return response
    })
  }
}

const mutations = {
  setStatus (state, status) {
    state.status = status
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
